<template>
  <div class="modal-card">
    <div class="modal-card-body">
      <div>
        <p class="mannequin-title">
          When choosing your body type, imagine a straight line from your
          shoulders to your hips.
        </p>
        <div class="mannequins-container">
          <div
            v-for="(shape, index) in shapes"
            :key="index"
            :class="storedShapeToken === shape.token ? 'higlighted' : null"
          >
            <ShapeMannequin
              :shape="shape"
              v-on:shape-selected="shapeSelected(shape)"
              :highlight="storedShapeToken === shape.token"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShapeMannequin from "@/components/ShapeMannequin";

export default {
  name: "ShapeGallerySelector",
  components: {
    ShapeMannequin,
  },
  data: function () {
    return {
      storedShapeToken: localStorage.getItem("style-number"),
      selectedShape: null,
      selectionModal: true,
      shapes: [
        {
          token: "red",
          displayToken: "A",
          color: "Red",
          image: require("@/assets/images/lady6.png"),
          features: [
            "Your shoulders and hips are in line.",
            "You have a defined waist."
          ],
        },
        {
          token: "orange",
          displayToken: "B",
          color: "Orange",
          image: require("@/assets/images/lady2.png"),
          features: [
            "Your shoulders are narrower than your hips.",
            "You have a defined waist."
          ],
        },
        {
          token: "blue",
          displayToken: "C",
          color: "Blue",
          image: require("@/assets/images/lady4.png"),
          features: [
            "Your shoulders and hips are in line.",
            "Your waist is not defined.",
          ],
        },
        {
          token: "purple",
          displayToken: "D",
          color: "Purple",
          image: require("@/assets/images/lady5.png"),
          features: [
            "Your shoulders are broader than your hips.",
            "Your waist is somewhat defined.",
          ],
        },
        {
          token: "green",
          displayToken: "E",
          color: "Green",
          image: require("@/assets/images/lady1.png"),
          features: [
            "Your shoulders are narrower than your hips.",
            "Your waist is not defined.",
          ],
        },
        {
          token: "yellow",
          displayToken: "F",
          color: "Yellow",
          image: require("@/assets/images/lady3.png"),
          features: [
            "Your shoulders and hips are in line.",
            "Your waist is not defined.",
          ],
        },
      ],
    };
  },
  created() {
    var styleNumber = localStorage.getItem("style-number");
    if (styleNumber) {
      this.selectedShape = this.shapes.filter((s) => {
        return s.token == styleNumber;
      })[0];
    }
  },
  methods: {
    shapeSelected(shape) {
      this.selectedShape = shape;
      this.selectionModal = false;
      this.confirmShape();
    },
    confirmShape() {
      this.$emit("shape-selected", this.selectedShape.token);
      localStorage.setItem("style-number", this.selectedShape.token);
      this.$parent.close();
    },
    changeShape() {
      this.selectionModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
div.modal-card-body {
  p.caption {
    font-style: italic;
    text-align: center;
  }
  .button.is-success {
    background-color: #8ec740;
  }
}

@media (max-width: 767px) {
  .confirm-shape {
    flex-direction: column-reverse;
    display: flex;
  }
}
.mannequins-container {
  display: grid;
  width: 100%;
  margin: auto;
  margin-bottom: 2.25rem;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
}
.mannequin-title {
  width: 70%;
  margin: auto;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
}
</style>

<style>
.VueCarousel-navigation .VueCarousel-navigation-prev {
  font-size: 1.5rem;
  color: #f69da4;
}
.VueCarousel-navigation .VueCarousel-navigation-next {
  font-size: 1.5rem;
  color: #f69da4;
}
</style>